import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhatIsSection() {
  const forYou = ['Te interesa una alternativa práctica desde casa sin complicarte', 'Quieres depender menos de soluciones rápidas, pero sin volverte "experto"', 'Te gusta tener "un plan" en vez de probar cosas al azar', 'Buscas ingredientes comunes, no suplementos caros ni importados'];
  const notForYou = ['Buscas una promesa milagro o un "remedio único para todo"', 'No quieres seguir instrucciones básicas de preparación (tiempos, cantidades)'];
  return <section className="py-16 px-4 bg-[#F0F4EC] border-t border-[#E8DFD0]" data-id="element-714">
      <div className="max-w-[800px] mx-auto" data-id="element-715">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-716">
          <p className="text-[#C17817] font-bold text-xs uppercase tracking-widest mb-2" data-id="element-717">
            Antes de continuar
          </p>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#2C1810]" data-id="element-718">
            ¿Es esto para ti?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-719">
          {/* For you */}
          <motion.div initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl border-2 border-[#2D5A3D]/30 p-6 shadow-sm" data-id="element-720">
            <div className="flex items-center gap-2 mb-5 pb-3 border-b border-[#E8DFD0]" data-id="element-721">
              <div className="w-6 h-6 rounded-full bg-[#2D5A3D] flex items-center justify-center shrink-0" data-id="element-722">
                <Check className="w-3.5 h-3.5 text-white" data-id="element-723" />
              </div>
              <h3 className="font-bold text-[#2D5A3D] uppercase tracking-wide text-sm" data-id="element-724">
                Esto es para ti si…
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-725">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-[#2C1810]" data-id="element-726">
                  <Check className="w-4 h-4 text-[#2D5A3D] mt-0.5 shrink-0" data-id="element-727" />
                  <span data-id="element-728">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not for you */}
          <motion.div initial={{
          opacity: 0,
          x: 10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl border-2 border-[#E8DFD0] p-6 shadow-sm" data-id="element-729">
            <div className="flex items-center gap-2 mb-5 pb-3 border-b border-[#E8DFD0]" data-id="element-730">
              <div className="w-6 h-6 rounded-full bg-[#5C4A3A] flex items-center justify-center shrink-0" data-id="element-731">
                <X className="w-3.5 h-3.5 text-white" data-id="element-732" />
              </div>
              <h3 className="font-bold text-[#5C4A3A] uppercase tracking-wide text-sm" data-id="element-733">
                Esto NO es para ti si…
              </h3>
            </div>
            <ul className="space-y-3 mb-6" data-id="element-734">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-[#5C4A3A]" data-id="element-735">
                  <X className="w-4 h-4 text-[#B91C1C] mt-0.5 shrink-0" data-id="element-736" />
                  <span data-id="element-737">{item}</span>
                </li>)}
            </ul>

            <div className="bg-[#F0F4EC] rounded-xl p-4 border border-[#E8DFD0]" data-id="element-738">
              <p className="text-xs text-[#5C4A3A] leading-relaxed" data-id="element-739">
                <span className="font-bold text-[#2C1810]" data-id="element-740">Importante:</span>{' '}
                Este es material educativo y de apoyo natural. No es diagnóstico
                ni tratamiento médico. Si tienes condiciones o tomas
                medicamentos, consulta a tu profesional de salud.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}